var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconError03 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 62 54"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CCC",
  strokeLinejoin: "round",
  strokeWidth: 5.2,
  d: "M32.811 4.017a2.6 2.6 0 0 0-4.504.034L3.738 47.384A2.6 2.6 0 0 0 6 51.267h50a2.6 2.6 0 0 0 2.242-3.916z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M27.667 20.333h5.5V37h-5.5zM27.667 44.5h5.5v-5.833h-5.5z"
})));
export default SvgIconError03;